import React, { useEffect } from "react";
import "./index.less";
import InputDateRangePicker from "../InputDatePicker";
import MultiSelectDD from "../multiSelectDD";
import sortBy from "lodash/sortBy";
import { IconButton, Tooltip } from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";

export default function TableHeaderWithFilter({
  columnData = [],
  isShowFilter = true,
  onChangeFilter = () => {},
  keepFilterData = false,
  reload,
  selectedSource,
  selectedId = {},
  refreshFilteredObj,
  clearData = false,
  refreshData = false,
  isDefaultFilter = false
}) {
  const [selectedIds, setSelectedIds] = React.useState(selectedId);
  // eslint-disable-next-line no-unused-vars
  const [forceUpdate, setForceUpdate] = React.useState(undefined);
  const [rerender, setRerender] = React.useState(false);

  useEffect(() => {
    setForceUpdate(reload);
    if (keepFilterData == true) {
      const arrObj = [];
      arrObj.push("All");
      for (let i = 0; i < selectedSource.length; i++) {
        const filterOptionList = selectedSource[i].value;
        if (filterOptionList.length > 0 || selectedId != null) {
          setSelectedIds(selectedId);
          setRerender(!rerender);
        }
      }
    }
  }, [reload]);

  useEffect(() => {
    if (clearData == true) {
      setSelectedIds({});
    }
  }, [refreshFilteredObj]);

  useEffect(() => {
    if (refreshData == true) {
      setSelectedIds(selectedId);
    }
  }, [refreshData]);

  /**
   * call on onchange event field
   * @param {*} keyName
   * @param {*} value
   * @param {*} filterType
   */
  function onChangeVal(keyName, value,obj, filterType = "string") {
    setSelectedIds({ ...selectedIds, [keyName]: value });
    if (obj.trim != false) {
      onChangeFilter(keyName, (value || "").trim(), filterType,0, obj);
    } else {
      onChangeFilter(keyName, (value || ""), filterType,0, obj);
    }
  }

  /**
   * call on Multiple selection field
   * @param {*} ids
   * @param {*} optionsList
   * @param {*} keyName
   * @param {*} filterType
   * @param {*} bit
   */
  function onMultiSelectDD(ids, optionsList, keyName, filterType, bit = 0, obj) {
    let allIds = optionsList.map(function(item) {
      return item.id;
    });
    const mIds = selectedIds[keyName] || [];
    if (ids.indexOf("All") !== -1) {
      const filteredIds = ids.filter(f => f != "All");

      if (
        filteredIds.length == allIds.length ||
        (ids.length > 0 && ids[0] == "All") ||
        (mIds.indexOf("All") == -1 && ids.indexOf("All") !== -1)
      ) {
        if (optionsList.length == 1 && ids[0] == "All") {
          allIds = [];
          setSelectedIds({ ...selectedIds, [keyName]: [] });
          onChangeFilter(keyName, allIds || [], filterType, bit, obj);
        } else {
          allIds.push("All");
          setSelectedIds({ ...selectedIds, [keyName]: allIds });
          onChangeFilter(keyName, allIds || [], filterType, bit, obj);
        }
      } else {
        const idsWithoutAll = ids.filter(f => f != "All");
        setSelectedIds({ ...selectedIds, [keyName]: idsWithoutAll });
        onChangeFilter(keyName, idsWithoutAll || [], filterType, bit, obj);
      }
    } else {
      if (mIds.indexOf("All") !== -1) {
        setSelectedIds({ ...selectedIds, [keyName]: [] });
        onChangeFilter(keyName, [], filterType, bit, obj);
        // setSelectedIds([]);
      } else {
        const idsWithoutAll = ids.filter(f => f != "All");
        if (idsWithoutAll.length == allIds.length) {
          allIds.push("All");
          // setSelectedIds(allIds);
          setSelectedIds({ ...selectedIds, [keyName]: allIds });
          onChangeFilter(keyName, allIds || [], filterType, bit, obj);
        } else {
          // setSelectedIds(ids);
          setSelectedIds({ ...selectedIds, [keyName]: ids });
          onChangeFilter(keyName, ids || [], filterType, bit, obj);
        }
      }
    }
  }


  /**
   * decide filter component depends upon conditions.
   * @param {*} obj
   * @returns
   */
  function decideFilterComp(obj, i) {
    switch (obj.filterType || "string") {
      case "string":
        return (
          <input
            id={obj.keyName}
            key={"input" + (obj.keyName || "")}
            value={selectedIds[obj.keyName] || ""}
            placeholder={obj.placeholder || ""}
            onChange={e =>
              onChangeVal(obj.keyName, e.target.value, obj, obj.filterType)}
          />
        );
      case "multiSelect":
        return (
          <MultiSelectDD
            // eslint-disable-next-line react/forbid-component-props
            key={"DropDown" + (obj.keyName || "")}
            className={"inline-filter"}
            header={""}
            minWidth={obj.width != undefined ? obj.width : "120px"}
            width={obj.width != undefined ? obj.width : "120px"}
            optionsList={sortBy(obj.optionsList, x => ((x["ListOrderBy"] === undefined ||
            x["ListOrderBy"] === null) ? x.value : x["ListOrderBy"]))}
            selectedIds={selectedIds[obj.keyName] || []}
            onChange={val =>
              onMultiSelectDD(val, obj.optionsList, obj.keyName, obj.filterType, 0, obj)}
            showToolTip
            index={i}
          />
        );
      case "dateRange":
        return (
          <InputDateRangePicker
            isDefaultFilter={isDefaultFilter}
            key={"dateRange" + (obj.keyName || "")}
            selectedVal={selectedIds[obj.keyName]}
            selectedIds={selectedIds[obj.keyName] || []}
            onChangeDate={value =>
              onChangeVal(obj.keyName, value, obj, obj.filterType)}
            className={obj.className}
          />
        );
    }
  }
  localStorage.setItem("IsInEditMode", 0);
  return (
    <>
      <tr
        className={"blue-cust-title headerWithFilter"}
        style={{ borderTop: "3px solid #FFFFFF" }}
      >
        {columnData.map((x, i) => (
          <th
            key={"th_" + i + (x.colName || "")}
            className={x.headerClass}
            style={{ textAlign: x.textAlign || "left" }}
          >
            {x.colName}
            {x.toolTip != undefined && x.toolTip != null && (
              <Tooltip title={x.toolTip}>
                <IconButton
                  style={{ pointerEvents: "auto" }}
                  size={"small"}
                  className={"tooltip-iconSize"}
                >
                  <InfoOutlined
                    style={{ fill: "white" }}
                    fontSize={"inherit"}
                  />
                </IconButton>
              </Tooltip>
            )}
          </th>
        ))}
      </tr>
      {isShowFilter ? (
        <tr className={"blue-cust-title headerWithFilter"}>
          {columnData.map((x, i) =>
            !x.isHideFilter ? (
              <th
                key={"th_control" + i}
                className={"filterInput " + x.headerClass}
                style={{ textAlign: x.textAlign || "left" }}
              >
                {decideFilterComp(x, i)}
              </th>
            ) : (
              <th key={"th_control" + i} />
            )
          )}
        </tr>
      ) : (
        ""
      )}
    </>
  );
}
